import angular from 'angular';
import uiRouter from 'angular-ui-router';
import reportsComponent from './reports.component';
import ReportingService from './reporting.Service';
import ShowroomTraffic from './showroomTraffic/showroomTraffic';
import FavoriteReports from './favoriteReports/favoriteReports';
import SalesReport from './salesReport/salesReport';
import AllEnquiries from './allEnquiries/allEnquiries';
import DealTimeline from './dealTimeline/dealTimeline';
import DeliveryPastEnquiries from './deliveryPastEnquiries/deliveryPastEnquiries';
import AppraisalAnalysis from './appraisalAnalysis/appraisalAnalysis';
import ContactsDataEntryMetric from './contactsDataEntryMetric/contactsDataEntryMetric';
import LostDealAnalysis from './lostDealAnalysis/lostDealAnalysis';
import MarketingConversion from './marketingConversion/marketingConversion';
import SalesPersonConversion from './salesPersonConversion/salesPersonConversion';
import ShowroomDetailed from './showroomDetailed/showroomDetailed';
import TestDrives from './testDrives/testDrives';
import TradePriceList from './tradePriceList/tradePriceList';
import LeadTracker from './leadTracker/leadTracker';
import ReportSummary from './reportSummary/reportSummary';
import ReportData from './reportData/reportData';
import FinanceDetail from './financeDetail/financeDetail';
import FinanceSummary from './financeSummary/financeSummary';
import BankSummary from './bankSummary/bankSummary';
import ModelEnquiry from './modelEnquiry/modelEnquiry';
import SalesTrend from './salesTrend/salesTrend';
import ReportableAddons from './reportableAddons/reportableAddons';
import SystemUsage from './adminReports/systemUsage/systemUsage';
import EnquiryPayments from './enquiryPayments/enquiryPayments';
import PromisesReport from './promisesReport/promisesReport';
import MarketingConsent from './marketingConsent/marketingConsent';
import DigitalSignatures from './digitalSignatures/digitalSignatures';
import SourceOfEnquiry from './SourceOfEnquiry/SourceOfEnquiry';
import SalesMatch from './salesMatch/salesMatch';
import LastLogin from './adminReports/lastLogin/lastLogin';
import VehicleImports from './adminReports/vehicleImports/vehicleImports';
import ReportsUsage from './adminReports/reportsUsage/reportsUsage';
import WeeklySalesActivity from './weeklySalesActivity/weeklySalesActivity';
import CashFlow from './cashFlow/cashFlow';

let reportsModule = angular.module('reports', [
  uiRouter,
  ShowroomTraffic,
  FavoriteReports,
  SalesReport,
  AllEnquiries,
  DealTimeline,
  DeliveryPastEnquiries,
  AppraisalAnalysis,
  ContactsDataEntryMetric,
  LostDealAnalysis,
  MarketingConversion,
  SalesPersonConversion,
  ShowroomDetailed,
  TestDrives,
  TradePriceList,
  LeadTracker,
  ReportSummary,
  ReportData,
  FinanceDetail,
  FinanceSummary,
  BankSummary,
  ModelEnquiry,
  SalesTrend,
  ReportableAddons,
  SystemUsage,
  EnquiryPayments,
  PromisesReport,
  MarketingConsent,
  DigitalSignatures,
  SourceOfEnquiry,
  SalesMatch,
  LastLogin,
  VehicleImports,
  ReportsUsage,
  WeeklySalesActivity,
  CashFlow
])

.config(($stateProvider) => {
    "ngInject";

  $stateProvider
    .state('reportsLanding', {
      component: 'reports',
      url: '/reports'
    });
})

.service('reportingService', ReportingService)

.component('reports', reportsComponent)

.name;

export default reportsModule;



// WEBPACK FOOTER //
// ./client/app/components/reports/reports.js